<nx-ng-modal-header title=""></nx-ng-modal-header>
<div class="header">
  <img
    class="logo"
    src="/assets/nationalexpress_logo.png"
    alt="{{ 'logo_alt_text' | i18next }}"
  />
  <span class="pipe">|</span>
  <h2 mat-dialog-title class="rewards">{{ 'nx_rewards' | i18next }}</h2>
</div>
<mat-dialog-content class="content">
  <h3 class="complete">{{ bookingMessage }}</h3>
  <p class="cashback">{{ 'rewards_cashback_amount' | i18next }}</p>
  <p class="claim">
    {{ 'rewards_cashback_1' | i18next }}&nbsp;
    <b>
      {{ 'rewards_cashback_amount' | i18next }}&nbsp;{{
        'rewards_cashback_2' | i18next
      }}</b
    >
    &nbsp;{{ 'rewards_cashback_3' | i18next }}
  </p>
</mat-dialog-content>
<div mat-dialog-actions class="bottom">
  <button
    mat-dialog-close
    cdkFocusInitial
    class="continue"
    [attr.aria-label]="'rewards_aria_continue' | i18next"
  >
    {{ 'button_continue' | i18next }}
  </button>
  <p class="terms">{{ 'rewards_terms' | i18next }}</p>
</div>
